<div class="d-flex flex-wrap align-items-start mb-6">
  <label [class.required]="required" class="col-12 col-form-label {{ columnClass.label }}">{{
    label
  }}</label>
  <div class="col-12 {{ columnClass.content }}">
    <div *ngIf="chipsListData && chipsListData.length > 0" class="mb-2">
      <app-chips
        (selectedChips)="handleDataOutput($event)"
        [chipsList]="chipsListData"
        [config]="{ disabled, showLimit: true }"
      ></app-chips>
    </div>
    <button
      *ngIf="!disabled"
      (click)="handleOpenModalForm()"
      [disabled]="disabled"
      [ngClass]="{
        'btn-outline': btnStyleOutline,
        'btn-outline--disabled': btnStyleDisabled,
      }"
      class="btn px-4"
      color="primary"
      mat-button
      type="button"
    >
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS" class="svg-icon svg-icon-2"></span>
      <span [ngClass]="{ 'text-gray-300': btnStyleDisabled }" class="text-primary"
        >Tambah {{ label }}</span
      >
    </button>
  </div>
</div>

<app-modal-form #modalForm [modalConfig]="modalFormConfig" [modalOptions]="{ size: 'md' }">
  <div *ngIf="listBox_selectedItems.value.length && showChipsModal" class="mb-4">
    <app-chips
      (selectedChips)="handleDataOutput($event)"
      [chipsList]="listBox_selectedItems.value"
      [config]="chipsConfig"
    ></app-chips>
  </div>

  <div class="multiselect-search mb-4">
    <div class="input-group">
      <input
        [formControl]="searchControl"
        [readOnly]="isLoading.value"
        class="form-control"
        ngDefaultControl
        placeholder="Silahkan cari {{ label }} disini"
        type="text"
      />
      <span class="input-group-text">
        <span [inlineSVG]="'./assets/media/icons/ic_search.svg'" class="svg-icon svg-icon-2"></span>
      </span>
    </div>
  </div>
  <ng-container *ngIf="isLoading.value; else afterLoadingTpl">
    <ng-container [ngTemplateOutlet]="loadingTpl" />
  </ng-container>
  <ng-template #afterLoadingTpl>
    <ng-container
      *ngIf="(listBox_listItems.value | filter: searchControl.value).length > 0; else noDataTpl"
    >
      <ng-container [ngTemplateOutlet]="listboxListTpl" />
    </ng-container>
  </ng-template>

  <ng-template #loadingTpl>
    <div class="d-flex justify-content-center align-items-center">
      <div class="my-7">
        <mat-spinner></mat-spinner>
        <div class="my-5">Loading Data</div>
      </div>
    </div>
  </ng-template>

  <ng-template #listboxListTpl>
    <div class="multiselect-list mh-330px min-h-330px overflow-auto mb-4">
      <div
        *ngFor="let item of listBox_listItems.value | filter: searchControl.value"
        class="form-check my-6 text-capitalize"
      >
        <input
          (change)="handleChangeSelection()"
          [(ngModel)]="item.selected"
          [ngModelOptions]="{ standalone: true }"
          [checked]="item['checked']"
          class="form-check-input cursor-pointer"
          id="flexCheckDefault-{{ item.id }}"
          type="checkbox"
        />
        <label
          class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize"
          for="flexCheckDefault-{{ item.id }}"
        >
          {{ item.name | lowercase
          }}<ng-container *ngIf="item.area || item.sub_area"
            >, {{ item.area || item.sub_area | lowercase }}</ng-container
          >
        </label>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button
        (click)="handleAddChipsList()"
        [disabled]="!listBox_selectedItems.value.length"
        class="btn btn-primary"
        type="button"
      >
        Tambahkan
      </button>
    </div>
  </ng-template>

  <ng-template #noDataTpl>
    <p class="pt-2">Tidak ada data...</p>
  </ng-template>
</app-modal-form>
